export default "__VITE_ASSET__4MJBNSOC__"